import { ZuoraLanguages } from '../types';
import { isRevenueLocation } from './isRevenueEnvironment';

/**
 * Resolves the nav i18n language for QueryClientProvider and useNavigationData.
 *
 * On Revenue surfaces (`isRevenueLocation`): prefer ZRevenue_UserLanguage, then
 * Billing identity, then 'en'.
 * Elsewhere: Billing identity → ZRevenue_UserLanguage → 'en' (legacy priority).
 */
export const resolvePreferredLanguage = ({
  billingLanguage,
  revenueUserLanguage,
  location = typeof document !== 'undefined' ? document.location : null,
}: {
  billingLanguage?: string | null;
  revenueUserLanguage?: string | null;
  location?: Parameters<typeof isRevenueLocation>[0];
}): ZuoraLanguages => {
  if (isRevenueLocation(location)) {
    return (
      (revenueUserLanguage as ZuoraLanguages) ||
      (billingLanguage as ZuoraLanguages) ||
      'en'
    );
  }

  return (
    (billingLanguage as ZuoraLanguages) ||
    (revenueUserLanguage as ZuoraLanguages) ||
    'en'
  );
};
